import React from 'react';
import Typography from '@mui/material/Typography';

export interface TitleComponentProps {
  title: string;
  display?: 'initial' | 'block' | 'inline';
}

export const TitleComponent = (props: TitleComponentProps) => {
  return (
    <Typography display={props.display} variant="h2">
      {props.title}
    </Typography>
  );
};
